<template>
    <Page>
        <Container>
            <div
                v-if="images.length"
                class="archive-tips tc-danger">长按图片可保存到相册</div>
            <div
                v-if="errorMsg"
                class="archive-error">{{ errorMsg }}</div>
            <XImage
                v-for="(item, index) in images"
                :key="index"
                width="100%"
                :src="item"
            ></XImage>
        </Container>
    </Page>
</template>

<script>
export default {
    name: 'TrainingArchivePage',
    data() {
        return {
            images: [],
            errorMsg: '',
        };
    },
    computed: {
        applyNo() {
            return this.$route.params.applyNo;
        },
    },
    methods: {
        async getArchive() {
            try {
                const { data } = await this.$api.Member.Ce.TrainingArchive.archiveInfo(
                    {
                        applyNo: this.applyNo,
                    },
                    {
                        isLoading: true,
                    },
                );
                this.images = (data || {}).images || [];
                if (!this.images.length) {
                    this.errorMsg = '未获取到培训档案';
                }
            } catch (e) {
                this.errorMsg = '培训档案获取失败，请稍后重试';
            }
        },
    },
    created() {
        this.getArchive();
    },
};
</script>

<style lang="scss">
.archive-tips {
    padding: $padding;
    text-align: center;
    font-size: $little * 100%;
}
.archive-error {
    padding: $padding;
    text-align: center;
    color: $color-text-minor;
}
</style>
